import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { reactive, computed, ref } from "vue";
import { message } from "ant-design-vue";
import { UserOutlined, LockOutlined } from "@ant-design/icons-vue";
import { postUserLogin } from "@/servers/api/user";
import router from "@/router";
import { useUserStore } from "@/store";
import { getClassesDetailApi } from "@/servers/api/classes";
import WechatLogin from "./WechatLogin.vue";
import type { QrLoginUser } from "@/utils/qrLogin";
interface FormParams {
  email: string;
  password: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const loginType = ref("account");
// 表单参数
const disabled = computed(() => {
  return !(formparams.email && formparams.password);
});

const formparams = reactive<FormParams>({
  email: "",
  password: "",
});

const userStore = useUserStore();

const completeLogin = async (user: QrLoginUser, signal?: AbortSignal) => {
  try {
    if (!user.teacher && user.student) {
      // 从res.data中获取对应的班级，然后根据班级获取对应的选科
      const classId = user.student.class_id;

      if (classId) {
        const r = await getClassesDetailApi(
          { class_id: classId },
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
            signal,
          }
        );
        // 在res.data中添加subject_selection字段
        if (r.data?.[0])
          user.student.subject_selection = r.data[0].subject_selection;
      }
    }

    if (signal?.aborted) return;
    // 资料准备完成后才保存身份，取消扫码时不留下旧账号。
    userStore.setUserInfo({
      ...user,
      token: user.token,
    });
    // 仍然保留token在localStorage中，方便API请求使用
    localStorage.setItem("token", user.token);
    if (user.teacher !== undefined) {
      await router.push("/teacher_info");
    } else {
      await router.push("/grade");
    }
  } catch (error) {
    if (signal?.aborted) return;
    localStorage.removeItem("token");
    userStore.clearUserInfo();
    throw error;
  }
};

const onFinish = async (values: API.Login) => {
  try {
    const res = await postUserLogin(values);
    await completeLogin(res.data);
  } catch (error: any) {
    console.error("登录失败:", error);
    const status = error?.response?.status;
    if (status === 401) {
      message.error("账号或密码错误，请重试");
    } else if (status === 400) {
      message.error("登录信息有误，请检查输入");
    } else if (status >= 500) {
      message.error("服务器繁忙，请稍后再试");
    } else {
      message.error("登录失败，请检查网络或联系管理员");
    }
  }
};

const onFinishFailed = () => {
  message.warning("请填写账号和密码");
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h2", null, "慧学成绩查询", -1)),
    _createVNode(_component_a_tabs, {
      activeKey: loginType.value,
      "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((loginType).value = $event)),
      centered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "account",
          tab: "账号密码登录"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              model: formparams,
              name: "normal_login",
              class: "login-form",
              onFinish: onFinish,
              onFinishFailed: onFinishFailed
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: "用户名",
                  name: "email",
                  rules: [{ required: true, message: '请输入用户名!' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formparams.email,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formparams.email) = $event))
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_unref(UserOutlined), { class: "site-form-item-icon" })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "密码",
                  name: "password",
                  rules: [
              { required: true, message: 'Please input your password!' },
            ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: formparams.password,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formparams.password) = $event))
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_unref(LockOutlined), { class: "site-form-item-icon" })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      disabled: disabled.value,
                      type: "primary",
                      "html-type": "submit",
                      class: "login-form-button"
                    }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode(" 登录 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled"]),
                    _cache[6] || (_cache[6] = _createTextVNode(" 或者 ", -1)),
                    _createVNode(_component_router_link, { to: "/user/register" }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("学生注册", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[7] || (_cache[7] = _createTextVNode(" | ", -1)),
                    _createVNode(_component_router_link, { to: "/user/teacher-register" }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("教师注册", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "wechat",
          tab: "微信扫码登录"
        }, {
          default: _withCtx(() => [
            (loginType.value === 'wechat')
              ? (_openBlock(), _createBlock(WechatLogin, {
                  key: 0,
                  "on-success": completeLogin
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeKey"])
  ]))
}
}

})